'use strict';

angular.module('subjectOpertionLogModule', []).directive('subjectOpertionLog', ['$filter', 'trsHttpService', 'editingCenterService', 'messagePublishService',
    function($filter, trsHttpService, editingCenterService, messagePublishService) {
        return {
            replace: true,
            restrict: 'EA',
            templateUrl: './editingCenter/directive/subjectOptionLog/index.html',
            scope: {
                metadataId: '=' // 专题稿件操作日志
            },
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function initStatus() {
                    $scope.status = {
                        isShow: false,
                        isRequesting: false, // 滚动请求时防抖
                        showSearchResult: false
                    };
                    $scope.data = {
                        copyVersion: [],
                        logs: {},
                        showLogNum: 3,
                        searchItems: [],
                        keywords: ''
                    };
                    $scope.page = {
                        CURRPAGE: 1,
                        PAGESIZE: 20,
                    };
                    $scope.searchPage = {
                        CURRPAGE: 1,
                        PAGESIZE: 20
                    };
                }

                /**
                 * [initData description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function initData() {
                    getVersion();
                    scroll();
                }

                /**
                 * [getVersion description] 获取流程版本与操作日志
                 * @param   {[type]}  id  [id description]
                 * @return  {[type]}      [return description]
                 */
                function getVersion(id) {
                    var metadataid = angular.isDefined(id) ? id : $scope.metadataId;
                    editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(function(data) {
                        $scope.data.version = data;
                        $scope.page = data.page;
                        $scope.data.copyVersion = data.copyArray;
                        $scope.status.hasVersionTime = true;
                        data.copyArray.forEach(function(version) {
                            getInnerDocLogs(version.METADATALOGID);
                        });
                    });
                }

                /**
                 * [getLoadMore description]操作日志加载更多
                 * @return {[type]} [description]
                 */
                $scope.getLoadMore = function() {
                    $scope.page.CURRPAGE++;
                    getVersion();
                };

                /**
                 * [getInnerDocLogs description] 获取专题稿内部日志
                 *
                 * @param  {[type]}  id   [id description] 稿件操作日志id
                 *
                 * @return  {[type]}   [return description]
                 */
                function getInnerDocLogs(id) {
                    var params = {
                        serviceid: 'mlf_specialdocinnerlog',
                        methodname: 'querySpecialNewOprLogsByIds',
                        MetaDataLogIds: id
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        formatData(data, id);
                    });
                }

                $scope.getMoreInnerLogs = function(log) {
                    var params = {
                        serviceid: 'mlf_specialdocinnerlog',
                        methodname: 'querySpecialRelatedInnerLogs',
                        SpecialDocLogIds: log.SPECIALDOCLOGIDS,
                        CurrPage: log.RELATEDOCLOGS.PAGER.CURRPAGE + 1
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        log.RELATEDOCLOGS.DATA = log.RELATEDOCLOGS.DATA.concat(data.DATA);
                        log.RELATEDOCLOGS.PAGER = data.PAGER;
                    });
                };
        
                /**
                 * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
                 * @param  {[type]}  key [description] 操作日志或流程版本的数据
                 * @return {Boolean}     [description]
                 */
                $scope.isShowVersion = function(key) {
                    if (key === undefined) {
                        return false;
                    } else {
                        for (var i in key) {
                            return true;
                        }
                        return false;
                    }
                };

                /**
                 * [formatData description]整理数据
                 *
                 * @param  {[type]}  data   [data description]
                 * @param  {[type]}  id   [id description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function formatData(data, id) {
                    $scope.data.logs[id] = data;
                }

                $scope.searchInnerLogs = function(ev, page) {
                    $('#scroll-require')[0].scrollTop = 0;
                    $scope.data.searchItems = [];
                    if (!$scope.data.keywords || !$scope.metadataId) {
                        $scope.status.showSearchResult = false;
                        return;
                    }
                    if ((angular.isDefined(ev) && ev.keyCode === 13) || angular.isUndefined(ev)) {
                        $scope.data.searchItems = [];
                        getSearchInnerLogs(page);
                    }
                };

                /**
                 * [getSearchInnerLogs description]
                 *
                 * @param  {[type]}  page   [page description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function getSearchInnerLogs(page) {
                    var params = {
                        serviceid: 'mlf_specialdocinnerlog',
                        methodname: 'querySpecialNewOprLogsBySearchWord',
                        searchWord: $scope.data.keywords,
                        MetaDataId: $scope.metadataId,
                        CurrPage: page || $scope.searchPage.CURRPAGE,
                        PageSize: 10
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        $scope.data.searchItems = $scope.data.searchItems.concat(data.DATA);
                        $scope.searchPage = data.PAGER;
                        $scope.status.showSearchResult = true;
                        $scope.status.isRequesting = false;
                    });
                }

                /**
                 * [scroll description] 滚动请求
                 *
                 * @param  {[type]}  e   [e description]
                 *
                 * @return  {[type]}   [return description]
                 */
                function scroll() {
                    var scrollDiv = $('#scroll-require');
                    var table = $('#scroll-require').find('table');
                    scrollDiv.scroll(function(e) {
                        if ($scope.status.isRequesting) {
                            return;
                        }
                        if (this.offsetHeight + this.scrollTop >= table.height() - 10 && $scope.searchPage.CURRPAGE < $scope.searchPage.PAGECOUNT && !$scope.status.isRequesting) {
                            $scope.status.isRequesting = true;
                            getSearchInnerLogs(++$scope.searchPage.CURRPAGE);
                        }
                    });
                }
                
                // 监听是否有修改窗口打开请求基础数据
                messagePublishService.subscribe('showSubjectOperLog', function (event, data) {
                    getVersion(data);
                }, $scope);
            }
        };
    }
]);
